import api from './base-api-v2';

// eslint-disable-next-line import/prefer-default-export
export const createTurnstileChallenge = (token) => api.request('post', '/v2/challenges', {
  withCredentials: true,
  params: {
    type: 'turnstile',
  },
  headers: {
    'cf-turnstile-invisible-token': token,
  },
  data: {},
});
